import React, { useState, useEffect } from "react";
import axios from "axios";
import Dividends from "../dividends/dividends.component";
import Dividendss from "../dividends/dividends_";

import { connect } from "react-redux";
import * as actions from "../../actions";
import Contract_obj from "../../getTronweb";
import metacoinConfig from "../../metacoin-config.js";
import styles from "./holdings.module.scss";

const Holdings = ({
  theme,
  contract,
  accounts,
  updated,
  setUpdated,
  ...props
}) => {
  const [tokens, setTokens] = useState();
  const [dividends, setDividends] = useState();
  const [balance, setBalance] = useState();

  const [cetoIfReinvested, setCetoIfReinvested] = useState();
  const [usd, setUsd] = useState();
  const [currenyArray, setCurrenyArray] = useState([]);

  const fetchData = async () => {
    // await Contract_obj.init();
    var obj1 = setInterval(async () => {
      await Contract_obj.contract_instace
        .myTokens()
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
        })
        .then(async res => {
          if (res) {
            // console.log(res.toString(), "TOKENS");
            setTokens(res.toString());
            clearInterval(obj1);

            if (parseInt(res.toString()) == 0) {
              setBalance(0);
            } else {
              await Contract_obj.contract_instace
                .tokensToTron_(res.toString())
                .call({
                  from: Contract_obj.accounts[0],
                  feeLimit: Contract_obj.feeLimit,
                })
                .then(function (tron) {
                  setBalance(tron.toString());
                });
            }
          }
        });
    }, 2);
    var obj2 = setInterval(async () => {
      await Contract_obj.contract_instace
        .calculateTokensReinvested()
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
        })
        .then(function (res) {
          if (res) {
            clearInterval(obj2);

            // console.log(res.toString(), "setTokens");
            setCetoIfReinvested(res.toString());
          }
        });
    }, 2);
    var obj3 = setInterval(async () => {
      await Contract_obj.contract_instace
        .myDividends(true)
        .call({
          from: Contract_obj.accounts[0],
          feeLimit: Contract_obj.feeLimit,
        })
        .then(function (res) {
          if (res) {
            clearInterval(obj3);

            // console.log(res.toString(), "myDividends");
            setDividends(res.toString());
          }
        });
    }, 2);
  };
  useEffect(() => {
    // console.log(contract, accounts, "contract", props);
    Object.keys(props.utils.currencies).map(function (key, index) {
      // console.log(key, props.utils.currencies[key]);
    });

    Contract_obj.contract_instace && fetchData();
    window.addEventListener("message", function (e) {
      if (e.data.message && e.data.message.action == "setNode") {
        // console.log("setNode event", e.data.message);

        if (
          window.tronWeb &&
          window.tronWeb.fullNode.host == metacoinConfig.fullHost
        ) {
          Contract_obj.contract_instace && fetchData();
        }
      }
      if (e.data.message && e.data.message.action == "setAccount") {
        Contract_obj.contract_instace && fetchData();
      }
    });
  }, []);
  useEffect(() => {
    var obj = setInterval(async () => {
      if (
        Contract_obj.contract_instace &&
        window.tronWeb &&
        window.tronWeb.defaultAddress.base58 &&
        (window.tronWeb.fullNode.host == metacoinConfig["mainnet"].fullHost ||
          window.tronWeb.fullNode.host == metacoinConfig["shasta"].fullHost)
      ) {
        clearInterval(obj);
        Contract_obj.contract_instace && fetchData();
      }
    }, 2);
    Contract_obj.contract_instace && fetchData();
  }, []);
  useEffect(() => {
    // console.log(updated, "updated");
    Contract_obj.contract_instace && fetchData();
  }, [updated]);
  return (
    <div className={styles.holdings}>
      <span className={styles.holdings__title}>Holdings</span>

      <div className={styles.holdingsCards}>
        <Dividends
          heading="tokens"
          value={`${tokens ? (tokens / 1e6).toFixed(3) : " "} CETO`}
          footer={[
            `${balance || balance == 0 ? (balance / 1e6).toFixed(3) : ""} TRX`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.USD).toFixed(2)
                : ""
            } USD`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.CHF).toFixed(2)
                : ""
            } CHF`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.EUR).toFixed(2)
                : ""
            } EUR`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.GIP).toFixed(2)
                : ""
            } GIP`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.KWD).toFixed(2)
                : ""
            } KWD`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.GBP).toFixed(2)
                : ""
            } GBP`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.JOD).toFixed(2)
                : ""
            } JOD`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.OMR).toFixed(2)
                : ""
            } OMR`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.BHD).toFixed(2)
                : ""
            } BHD`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.CAD).toFixed(2)
                : ""
            } CAD`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.INR).toFixed(2)
                : ""
            } INR`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.JPY).toFixed(2)
                : ""
            } JPY`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.HKD).toFixed(2)
                : ""
            } HKD`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.PAB).toFixed(2)
                : ""
            } PAB`,
            `${
              balance || balance == 0
                ? ((balance / 1e6) * props.utils.currencies.AED).toFixed(2)
                : ""
            } AED`,
          ]}
        />
        <Dividendss
          heading="dividends"
          value={`${
            dividends ? (dividends / 1e6).toFixed(3) : ""
          } TRX`}
          footer={[
            `${
              cetoIfReinvested ? (cetoIfReinvested / 1e6).toFixed(2) : " "
            } CETO (if reinvested)`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.USD).toFixed(2)
                : ""
            } USD`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.CHF).toFixed(2)
                : ""
            } CHF`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.EUR).toFixed(2)
                : ""
            } EUR`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.GIP).toFixed(2)
                : ""
            } GIP`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.KWD).toFixed(2)
                : ""
            } KWD`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.GBP).toFixed(2)
                : ""
            } GBP`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.JOD).toFixed(2)
                : ""
            } JOD`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.OMR).toFixed(2)
                : ""
            } OMR`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.BHD).toFixed(2)
                : ""
            } BHD`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.CAD).toFixed(2)
                : ""
            } CAD`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.INR).toFixed(2)
                : ""
            } INR`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.JPY).toFixed(2)
                : ""
            } JPY`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.HKD).toFixed(2)
                : ""
            } HKD`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.PAB).toFixed(2)
                : ""
            } PAB`,
            `${
              dividends
                ? ((dividends / 1e6) * props.utils.currencies.AED).toFixed(2)
                : ""
            } AED`,
          ]}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  // console.log(state, "state");
  return {
    utils: state.utils,
  };
};

export default connect(mapStateToProps, actions)(Holdings);
